import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full h-full overflow-hidden max-w-14xl text-warm-gray-700 text-sm mx-auto flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rating_head_bar = _resolveComponent("rating-head-bar")!
  const _component_rating_list = _resolveComponent("rating-list")!
  const _component_f_tab_pane = _resolveComponent("f-tab-pane")!
  const _component_lecture_list = _resolveComponent("lecture-list")!
  const _component_f_tabs = _resolveComponent("f-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_rating_head_bar),
    _createVNode(_component_f_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['最新'], (tabName) => {
          return _createVNode(_component_f_tab_pane, {
            key: tabName,
            tab: tabName
          }, {
            default: _withCtx(() => [
              _createVNode(_component_rating_list, {
                active: _ctx.activeTab === tabName,
                type: tabName
              }, null, 8, ["active", "type"])
            ]),
            _: 2
          }, 1032, ["tab"])
        }), 64)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['七模', '思政', '外语', '体育'], (tabName) => {
          return _createVNode(_component_f_tab_pane, {
            key: tabName,
            tab: tabName
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lecture_list, {
                active: _ctx.activeTab === tabName,
                type: tabName
              }, null, 8, ["active", "type"])
            ]),
            _: 2
          }, 1032, ["tab"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}